/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_EllipsisInputs */

const en_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export...`)
};

const fr_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter...`)
};

const de_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export...`)
};

const it_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportare...`)
};

const ru_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт...`)
};

const es_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar...`)
};

const zh_cn2_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口...`)
};

const ja_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸出...`)
};

const hi_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात करना...`)
};

const pt_pt2_export_ellipsis = /** @type {(inputs: Export_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar...`)
};

/**
* | output |
* | --- |
* | "Export..." |
*
* @param {Export_EllipsisInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const export_ellipsis = /** @type {((inputs?: Export_EllipsisInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_EllipsisInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_export_ellipsis(inputs)
	if (locale === "de") return de_export_ellipsis(inputs)
	if (locale === "it") return it_export_ellipsis(inputs)
	if (locale === "ru") return ru_export_ellipsis(inputs)
	if (locale === "es") return es_export_ellipsis(inputs)
	if (locale === "zh-CN") return zh_cn2_export_ellipsis(inputs)
	if (locale === "ja") return ja_export_ellipsis(inputs)
	if (locale === "hi") return hi_export_ellipsis(inputs)
	if (locale === "pt-PT") return pt_pt2_export_ellipsis(inputs)
	return en_export_ellipsis(inputs)
});